<template>
  <v-dialog v-model="dialog" width="1200px">
    <v-card>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close"> Fechar </v-btn>
      </v-card-actions>
      <v-card-title>
        <span class="headline">Importar</span>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-file-input
            accept="*"
            label="File input"
            v-model="file"
          ></v-file-input>

          <v-btn class="primary" @click="importFile(file)">Load </v-btn>
            <v-btn class="primary" @click="saveImport">Importar</v-btn>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="">Contato</th>
                <th class="">Cidade</th>
                
                <th class="">Yield</th>
                <th class="">Classe</th>
                <th class="">Tipo Fase</th>
                <th class="">Tipo telhado</th>
                <th class="">Tarifa</th>
                <th class="">Consumo kWh</th>
                <th class="">Potência Dc</th>
                <th class="">Potência Módulo</th>
                <th class="">Produção</th>
                <th class="">Custo  </th>
                <th class="">Custo materiais</th>
                <th class="">Custo instalação</th>
                <th class="">Custo projeto</th>
                <th class="">Preço target </th>
                
                <th class="">Preço </th>
                <th class="">Obs </th>
                

              </tr>
            </thead>
            <tbody>
              <tr v-for="item in objectsImport" v-bind:key="item.id">
                <td>{{ item.cliente.nome }}</td>
                <td>{{ item.cliente.cidade }}</td>
                <td>{{ item.uc.yield }}</td>
                <td>{{ item.uc.classe }}</td>
                <td>{{ item.uc.tipoFase }}</td>
                <td>{{ item.uc.tipoTelhado }}</td>
                <td>{{ item.uc.tarifa }}</td>
                <td>{{ item.uc.consumoKwh }}</td>

                <td><span v-decimal-format = "item.sistema.potencia " > </span>kWp</td>
                <td> {{(item.sistema.potenciaPlaca*1000).toFixed(0) }}Wp </td>
                <td>{{ item.sistema.prodKwh }}</td>
                
                <td>{{ item.sistema.custo }}</td>
                <td>{{ item.sistema.custoMateriais }}</td>
                <td>{{ item.sistema.custoInstalacoes }}</td>
                <td>{{ item.sistema.custoProjeto }}</td>
                <td>{{ item.sistema.precoSugerido }}</td>

                <td>{{ item.valorProposto }}</td>
                <td>{{ item.obs }}</td>
                

                <td class=""></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-text>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="saveImport">Importar</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Contact from "../../../../libraries/classes/Contact";
import Deal from "../../../../libraries/classes/Deal";
import Project from "../../../../libraries/classes/Project";

import hebelApi from "../../../../libraries/hebel/hebelApi";
import ContactCardVue from '../cards/ContactCard.vue';

export default {
  components: {},
  name: "modal-import-deals",
  props: ["dialog"],
  data() {
    return {
      objectsImport: [],
      file: null,
      deals:[],
      contacts:[],
      project:{},
      modules:[]
    };
  },

  watch: {},
  computed: {},
  created() {},
  async mounted() {
      this.deals = await hebelApi.deals.getAll();
        this.contacts = await hebelApi.contacts.getAll();
        this.modules  = await hebelApi.devices.getAllModules();
        //alert("mounted")
  },

  methods: {
    close() {
      this.$emit("close");
    },
    async saveImport() {

        for(var o= 0; o < this.objectsImport.length ; o++){
            
            console.log("import object:" + o);

            var item= this.objectsImport[o];

            var contact = this.contacts.find(value => value.name == item.cliente.nome);
            //alert(JSON.stringify(contact));

            var deal = new Deal()
            deal.title = `Proposta: ${item.cliente.nome}`
            deal.contacId = contact.id;
            deal.contact = contact;
            deal.contactName = contact.name;
            var x = await hebelApi.deals.upsert(deal);
            deal.id = x.id;

            //return;

            var project = new Project();
            project.contactId = contact.id;
            project.dealId=  deal.id;


            project.contact = contact;
            project.site.cityName = item.uc.cidade.nome;
            project.site.city =await hebelApi.cities.get( project.site.cityName);
            project.site.zipCode = item.cliente.cep;
            project.site.streetAddress = item.cliente.rua;
            project.site.neighborhood = item.cliente.bairro;
            project.site.streetAddressNumber = item.cliente.numero;
            project.site.streetAddressLine2 = item.cliente.complemento;

            project.site.electricalProps.averageBilling.price = parseFloat(item.uc.tarifa);
            project.site.electricalProps.averageBilling.quantity =  parseFloat(item.uc.consumoKwh) ;
            project.site.electricalProps.averageBilling.total =  parseFloat(item.uc.tarifa * item.uc.consumoKwh);
            project.site.electricalProps.averageBilling.type = item.uc.classe;
                
            if(item.uc.tipoFase =="Monofásico" ){
                project.site.electricalProps.phases = 1;
                project.site.electricalProps.averageBilling.minAmount = 30;
            }
            if(item.uc.tipoFase =="Bifásico" ){
                project.site.electricalProps.phases = 2;
                project.site.electricalProps.averageBilling.minAmount = 50;
            }
            if(item.uc.tipoFase =="Trifásico" ){
                project.site.electricalProps.phases = 3;
                project.site.electricalProps.averageBilling.minAmount = 100;
            }

            project.site.solarRequest.manufacturer = "BADENSOLAR";
            project.site.solarRequest.dcPower = parseFloat( item.sistema.potencia);
            project.site.solarRequest.consumption = project.site.electricalProps.averageBilling.quantity;
            project.site.solarRequest.production =parseFloat(  item.sistema.prodKwh);
            project.site.solarRequest.estimated = true;
        
            //var modules = await hebelApi.devices.getFromId( this.site.solarRequest.moduleId)
            var dcPoweWp = parseFloat(item.sistema.potenciaPlaca)*1000;
            var module = this.modules.find(value => value.dcPowerWp ==dcPoweWp )
            
            // alert(JSON.stringify(module));
            // return;
            project.site.solarRequest.module = module;


            console.log("will calc")
            await project.calc();
            project.quote.price = parseFloat(item.valorProposto);
            project.quote.obs = item.obs;

            this.project = project;  
            

            var ans = await hebelApi.projects.upsert(project);
                
        };
        //alert(JSON.stringify(ans));
        alert("Finish")
        //alert(JSON.stringify(project))

    //   //  alert("save import")
    //   var newdeals = [];
    //   var a =0;
    //   for(a= 0; a < this.objectsImport.length; a++){
    //     var item = this.objectsImport[a];
    //     var c = new Contact();
    //     console.log(JSON.stringify(c));
    //     c.name =  item.cliente.nome;
    //     c.email = item.cliente.email;
    //     c.zipCode = item.cliente.cep;
    //     c.streetAddress = item.cliente.rua;
    //     c.neighborhood = item.cliente.bairro;
    //     c.streetAddressNumber = item.cliente.numero;
    //     c.streetAddressLine2 = item.cliente.complemento;
    //     c.cityName = item.cliente.cidade;
    //     c.phone = item.cliente.telefone;
    //     c.phone = item.cliente.celular;
    //     newdeals.push(c);
    //   };

    //   var filtereddeals = [];
    //   for(a = 0; a < newdeals.length; a++ ){
    //       var item = newdeals[a];
    //       console.log(JSON.stringify(item))
    //       console.log(JSON.stringify(a));

    //       var foundItem = filtereddeals.find(value => ((value.name == item.name)||( (value.email !="")&& (value.email == item.email) ) ) )
    //       var foundItem2 = this.deals.find(value => ((value.name == item.name)||( (value.email !="") && (value.email == item.email)  ) ) )
    //       //alert(JSON.stringify(foundItem2))
    //       if((foundItem || foundItem2)){
    //          //alert(JSON.stringify(foundItem));
    //       }else{
    //         filtereddeals.push(item);
    //       }
    //   };
    //   console.log(JSON.stringify(filtereddeals));
    //   for (a = 0 ; a < filtereddeals.length ;a++){
    //     console.log(JSON.stringify(a));
    //     var addContact = filtereddeals[a];
    //     console.log(JSON.stringify(addContact));
    //     console.log("Will add contact")
    //     var ans = await hebelApi.deals.upsert(addContact);
    //   }
    //   console.log("Finish")

    },


    async importFile(file) {
      if (file) {
        var json = await this.$globalFunctions.readFileAsync(file);
        console.log(json);
        var objectsImport = JSON.parse(json);
        this.objectsImport =[];
        
        //for (var a = 0; a <5; a++){
         for (var a = 0; a <objectsImport.length; a++){
       
            this.objectsImport.push(objectsImport[a])
        }
        //alert(JSON.stringify(this.objectsImport))
        this.$forceUpdate();
      }
    },
  },
};
</script>


<style scoped>
</style>